import { queryAPI } from '../../utils/queryApi';
import gql from 'fake-tag';

export async function resetClientData(id: string) {
  return queryAPI<{ resetClientData: boolean }>(
    gql`
      mutation ResetClientData($args: ID!) {
        resetClientData(id: $args)
      }
    `,
    { args: id }
  );
}
